import styles from "./testrailResult.module.scss";
import {
  ResultEnum,
  TransformExecuteResponse
} from "../../../types/clientTypes";
import loader from "../../images/loader-execute.gif";
import { ReactComponent as CloseIcon } from "../../images/close.svg"
import { ReactComponent as SuccessIcon } from "../../images/success.svg"
import { useTranslation } from "react-i18next";

type TestrailResultProps = {
  executeResponse: TransformExecuteResponse;
}

export const TestrailResult = ({executeResponse}: TestrailResultProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {!!executeResponse.testrailResult && (
        <>
          {executeResponse.testrailResult === ResultEnum.failed && (<CloseIcon className={styles.error}/>)}
          {executeResponse.testrailResult === ResultEnum.passed && (<SuccessIcon/>)}
          <span>{t("common.testRail")}</span>
        </>
      )}
      {!!executeResponse.isLoadTestrail && (
        <img src={loader} alt=""/>
      )}
    </div>
  );
}